import { render, staticRenderFns } from "./staff-list-dialog.vue?vue&type=template&id=5860da8b&"
import script from "./staff-list-dialog.vue?vue&type=script&lang=js&"
export * from "./staff-list-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports